<template>
    <component
        :is="sidebarComponent"
        v-bind="$attrs"
        @update:expanded="emit('update:expanded', $event)"
    />
</template>

<script setup>
import CorporateAdminSidebar from '@/components/sidebar/CorporateAdminSidebar.vue';
import CorporateStudentSidebar from '@/components/sidebar/CorporateStudentSidebar.vue';
import { resolveCorporateView } from '@/composables/useCorporateUserRole.js';

// Role-axis resolver for the corporate client variant sidebar. The client axis is
// resolved by `DashboardSidebar.vue`; this file then picks between the
// corporate admin and corporate student variants based on user roles. See
// docs/domains/client-variants.md for the two-axis pattern.
defineOptions({
    name: 'CorporateSidebar',
    inheritAttrs: false,
});

const emit = defineEmits(['update:expanded']);

const sidebarComponent = resolveCorporateView({
    admin: CorporateAdminSidebar,
    student: CorporateStudentSidebar,
});
</script>
